import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RBACGuard } from './guards/rbac.guard';

export const routes: Routes = [
  { 
    path: '',
    loadComponent: () =>
      import('./home/home.component').then((m) => m.HomeComponent),
    canActivate: [MsalGuard],
  },
  {
    path: 'logout',
    loadComponent: () =>
      import('./components/logout/logout.component').then(
        (m) => m.LogoutComponent
      ),
  },
  {
    path: 'user-management',
    loadComponent: () =>
      import('@components/user-management/user-management.component').then(
        (m) => m.UserManagementComponent
      ),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'user-access-management',
    loadComponent: () =>
      import('./components/user-access-management/user-access-management.component').then(
        (m) => m.UserAccessManagementComponent
      ),
    canActivate: [MsalGuard, RBACGuard]
  },
  {
    path: 'user-access-management/:id',
    loadComponent: () =>
      import('./components/user-access-management/user-access-management.component').then(
        (m) => m.UserAccessManagementComponent
      ),
    canActivate: [MsalGuard, RBACGuard]
  },
  {
    path: 'approval-request',
    loadComponent: () =>
      import('./components/approval-request/approval-request.component').then(
        (m) => m.ApprovalRequestComponent
      ),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'approval-request/:module',
    loadComponent: () =>
      import('./components/approval-request/approval-request.component').then(
        (m) => m.ApprovalRequestComponent
      ),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'my-workspace/:mode',
    loadComponent: () =>
      import('@components/workspace/workspace.component').then(
        (m) => m.WorkspaceComponent
      ),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'project-list-detail',
    loadComponent: () =>
      import(
        '@components/project-details/project-management/project-management.component'
      ).then((m) => m.ProjectManagementComponent),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'assessment-detail/:module/:id',
    loadComponent: () =>
      import('@components/ipor-readiness-assessment/ipor-readiness-assessment.component').then(
        (m) => m.IporReadinessAssessmentComponent
      ),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'assessment-detail/:id',
    loadComponent: () =>
      import('@components/ipor-readiness-assessment/ipor-readiness-assessment.component').then(
        (m) => m.IporReadinessAssessmentComponent
      ),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'project-detail/:id',
    loadComponent: () =>
      import('@components/project-details/project-details.component').then(
        (m) => m.ProjectDetailsComponent
      ),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'project-detail/:module/:id',
    loadComponent: () =>
      import('@components/project-details/project-details.component').then(
        (m) => m.ProjectDetailsComponent
      ),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'project-detail/:module/:id/:componentid/:type',
    loadComponent: () =>
      import('@components/project-details/project-details.component').then(
        (m) => m.ProjectDetailsComponent
      ),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'project-detail-form',
    loadComponent: () =>
      import(
        '@components/project-details-form/project-details-form.component'
      ).then((m) => m.ProjectDetailsFormComponent),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'project-detail-form/:id',
    loadComponent: () =>
      import(
        '@components/project-details-form/project-details-form.component'
      ).then((m) => m.ProjectDetailsFormComponent),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('@components/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'onedb-upload',
    loadComponent: () =>
      import('@components/masterdata-upload/masterdata-upload.component').then(
        (m) => m.MasterdataUploadComponent
      ),
    canActivate: [MsalGuard, RBACGuard],
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('@components/settings/settings.component').then(
        (m) => m.SettingsComponent
      ),
    canActivate: [MsalGuard],
  },
];